// export const url="http://localhost:3000/bulkmail/"

let localIp="http://192.168.0.105";
export const url=process.env.NODE_ENV==="development" ? `${localIp}:5001/bulkmail.xynes.com`:"https://bulkmail.xynes.com/api";
// let localIp="http://localhost";